import { inject, Injectable } from '@angular/core';
import { IDownloadDetailApiService } from './download-detail-api.interface';
import { map, Observable } from 'rxjs';
import { DownloadDetail } from '../domain/download-detail.model';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponseApi } from '@domain/shared/infrastructure/models/response-api.interface';
import { mapDownloadDetailApiModelToDomain } from '../mappers/download-detail.mappers';
import { DownloadDetailApiModel } from './download-detail-api.model';

@Injectable({
  providedIn: 'root',
})
export class DownloadDetailApiService implements IDownloadDetailApiService {
  private readonly _baseUrl = environment.baseUrl;
  private readonly _http = inject(HttpClient);

  getDownloadDetails(queryParams?: {
    activityId?: number;
  }): Observable<DownloadDetail[] | DownloadDetail> {
    const { activityId } = queryParams || {};
    const url = `${this._baseUrl}download-detail-platform?activityId=${activityId}`;
    const headers = new HttpHeaders();
    return this._http.get<ResponseApi>(url, { headers }).pipe(
      map((response) => {
        if (Array.isArray(response.results)) {
          return response.results.map((item) =>
            mapDownloadDetailApiModelToDomain(item)
          );
        }

        return mapDownloadDetailApiModelToDomain(
          response.results as DownloadDetailApiModel
        );
      })
    );
  }

  createDownloadDetail(activityId: number): Observable<DownloadDetail> {
    const url = `${this._baseUrl}download-detail-platform/${activityId}`;
    const headers = new HttpHeaders();
    return this._http
      .post<ResponseApi>(url, { headers })
      .pipe(
        map((response) =>
          mapDownloadDetailApiModelToDomain(
            response.results as DownloadDetailApiModel
          )
        )
      );
  }

  updateDownloadDetail(
    id: number, 
    data: {
      pathPod?: string;
    }
  ): Observable<DownloadDetail> {
    let url = `${this._baseUrl}download-detail-platform/${id}?`;

    if (data.pathPod) {
      url += `path_pod=${data.pathPod}&`;
    }
    const headers = new HttpHeaders();

    return this._http.patch<ResponseApi>(url, { headers }).pipe(
      map((response) =>
        mapDownloadDetailApiModelToDomain(
          response.results as DownloadDetailApiModel
        )
      )
    );
  }

  deleteDownloadDetail(id: number): Observable<boolean> {
    const url = `${this._baseUrl}download-detail-platform/${id}`;
    const headers = new HttpHeaders();
    return this._http.delete<ResponseApi>(url, { headers }).pipe(
      map((response) => {
        return response.ok;
      })
    );
  }
}
